import * as types from '../actions/actionTypes';
import { definitionTree, definitionTarget, sharedList } from './initialState';

const initialState = { definitionTree, definitionTarget, sharedList };

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_DEFINITION_TREE_LOAD: {
      return {
        ...state,
        definitionTree: {
          ...action.payload,
          data:
            action.payload.status === 'SUCCESS'
              ? action.payload.data.filter(
                  definition =>
                    !(
                      (definition.scope === 1 ||
                        definition.scope === 3 ||
                        definition.scope === 5) &&
                      action.productNo !== definition.productId
                    ),
                )
              : [],
        },
      };
    }
    case types.GET_DEFINITION_TREE_LIST_LOAD: {
      return {
        ...state,
        definitionTreeList: {
          ...action.payload,
          data:
            action.payload.status === 'SUCCESS'
              ? action.payload.data.filter(
                  definition =>
                    !(
                      (definition.scope === 1 ||
                        definition.scope === 3 ||
                        definition.scope === 5) &&
                      action.productNo !== definition.productId
                    ),
                )
              : [],
        },
      };
    }
    case types.GET_DEFINITION_TARGET_LOAD: {
      return {
        ...state,
        definitionTarget: action.payload,
      };
    }
    case types.DELETE_DEFINITION_TARGET: {
      return {
        ...state,
        definitionTarget: undefined,
      };
    }
    case types.UPDATE_DEFINITION: {
      return {
        ...state,
        definitionTree: {
          ...state.definitionTree,
          data:
            action.payload.status === 200 &&
            action.payload.data &&
            action.payload.data.folderName
              ? state.definitionTree.data.map(definition => {
                if (
                  definition.definitionId !== action.payload.data.definitionId
                ) {
                  return {
                    ...definition,
                    folderName: action.payload.data.folderName,
                  };
                }
                return definition;
              })
              : state.definitionTree.data,
        },
      };
    }
    case types.GET_SHARED_DEFINITION_LIST: {
      return {
        ...state,
        sharedList: action.payload,
      };
    }
    default:
      return state;
  }
}
